// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Box, Typography } from '@mui/material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';
// import { useTranslation } from 'react-i18next';

// export const StaffDailyCourtCasesComponent = () => {
//   const { t } = useTranslation();

//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: t('dailyCourt.slNo'), width: 20 },
//     { id: 'case_no', field: 'case_no', headerName: t('dailyCourt.caseNo'), width: 100 },
//     { id: 'kpid_sec', field: 'kpid_sec', headerName: t('dailyCourt.kpidSec'), width: 100 },
//     { id: 'petitioner', field: 'petitioner', headerName: t('dailyCourt.petitioner'), width: 150 },
//     { id: 'respondants', field: 'respondants', headerName: t('dailyCourt.respondants'), width: 150 },
//     { id: 'status', field: 'status', headerName: t('dailyCourt.status'), width: 100 },
//     {
//       id: 'links',
//       field: 'links',
//       headerName: t('dailyCourt.links'),
//       width: 120,
//       renderCell: (params) => (
//         <a href={params.value} target="_blank" rel="noopener noreferrer">
//           {t('dailyCourt.download')}
//         </a>
//       ),
//     },
//   ];

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/home-notification/daily-court-orders/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           case_no: item.case_no,
//           kpid_sec: item.kpid_sec,
//           petitioner: item.petitioner,
//           respondants: item.respondants,
//           status: item.status,
//           links: item.link,
//         }));
//         setRows(apiData);
//         setSnackbarMessage(t('dailyCourt.successMessage'));
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch daily court cases:', error);
//         setSnackbarMessage(t('dailyCourt.errorMessage'));
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   }, [t]);

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
//         <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
//           {t('dailyCourt.heading')}
//         </Typography>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus={true}
//         enableSort={true}
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';
import { useTranslation } from 'react-i18next';

export const StaffDailyCourtCasesComponent = () => {
  const { t } = useTranslation();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: t('dailyCourt.slNo'), width: 20 },
    { id: 'case_no', field: 'case_no', headerName: t('dailyCourt.caseNo'), width: 100 },
    { id: 'kpid_sec', field: 'kpid_sec', headerName: t('dailyCourt.kpidSec'), width: 100 },
    { id: 'petitioner', field: 'petitioner', headerName: t('dailyCourt.petitioner'), width: 150 },
    { 
      id: 'advocate_name', 
      field: 'advocate_name', 
      headerName: t('highCourt.advocateName'), 
      width: 140 
    },
    { id: 'respondants', field: 'respondants', headerName: t('dailyCourt.respondants'), width: 150 },
    { 
      id: 'date_of_filling', 
      field: 'date_of_filling', 
      headerName: t('highCourt.dateOfFilling'), 
      width: 120 
    },
    { 
      id: 'previous_date_of_hearing', 
      field: 'previous_date_of_hearing', 
      headerName: t('highCourt.previousDate'), 
      width: 130 
    },
    { 
      id: 'next_date_of_hearing', 
      field: 'next_date_of_hearing', 
      headerName: t('highCourt.nextDate'),
      width: 130 
    },
    { 
      id: 'appearence_by', 
      field: 'appearence_by', 
      headerName: t('highCourt.apearenceBY'), 
      width: 140 
    },
    { id: 'status', field: 'status', headerName: t('dailyCourt.status'), width: 140 },
    // {
    //   id: 'links',
    //   field: 'links',
    //   headerName: t('dailyCourt.links'),
    //   width: 120,
    //   renderCell: (params) => (
    //     <a href={params.value} target="_blank" rel="noopener noreferrer">
    //       {t('dailyCourt.download')}
    //     </a>
    //   ),
    // },

    {
  id: 'links',
  field: 'links',
  headerName: t('advertisement.links'),
  width: 120,
  renderCell: (params) => {
    if (!params.value) {
      return <span>Not Found</span>;
    }
    return (
      <a href={params.value} target="_blank" rel="noopener noreferrer">
        {t('advertisement.download')}
      </a>
    );
  },
},

  ];

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/home-notification/daily-court-orders/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          case_no: item.case_no,
          kpid_sec: item.kpid_sec,
          petitioner: item.petitioner,
          advocate_name: item.advocate_name,
          respondants: item.respondants,
          date_of_filling: item.date_of_filling,
          previous_date_of_hearing: item.previous_date_of_hearing,
          next_date_of_hearing: item.next_date_of_hearing,
          appearence_by: item.appearence_by,
          status: item.status || '',
          links: item.link,
        }));
        setRows(apiData);
        setSnackbarMessage(t('dailyCourt.successMessage'));
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch daily court cases:', error);
        setSnackbarMessage(t('dailyCourt.errorMessage'));
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, [t]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          {t('dailyCourt.heading')}
        </Typography>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus={true}
        enableSort={true}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
